const session = {
  reads: 0,
  writes: 0,
  deletes: 0,
  timeline: [],
};

export function trackRead(count = 1) {
  session.reads += count;
  session.timeline.push({ type: "read", count, at: new Date().toISOString() });
}

export function trackWrite(count = 1) {
  session.writes += count;
  session.timeline.push({ type: "write", count, at: new Date().toISOString() });
}

export function trackDelete(count = 1) {
  session.deletes += count;
  session.timeline.push({ type: "delete", count, at: new Date().toISOString() });
}

export function getSessionStats() {
  return { ...session, timeline: [...session.timeline].slice(-50) };
}

export function resetSession() {
  session.reads = 0;
  session.writes = 0;
  session.deletes = 0;
  session.timeline = [];
}
